import { render } from "./Affichage-tvView.vue?vue&type=template&id=00c991b0"
import script from "./Affichage-tvView.vue?vue&type=script&lang=js"
export * from "./Affichage-tvView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__